<template>
  <div class="flex flex-col gap-3">
    <div
      v-for="(schema, idx) in schema_array"
      :key="`${schema.field_name}-${schema.read_only}-${idx}`"
      class="bg-bg-canvas p-4 rounded-xl"
    >
      <div class="text-strongest font-semibold text-lg font-inter mb-4">
        {{ idx + 1 }}. {{ schema.label }}
      </div>
      <div
        v-if="schema.field_name !== 'investment_objective' && state_object[schema.field_name]"
        class="font-inter text-base font-semibold text-strongest"
      >
        {{ state_object[schema.field_name] }}
      </div>
      <div
        v-else-if="schema.field_name === 'investment_objective' && state_object[schema.field_name]"
      >
        <div class="font-inter text-base font-semibold text-strongest mb-1">
          {{ state_object[schema.field_name]?.split("-")[0] }}
        </div>
        <div class="font-inter text-sm font-medium text-stronger">
          {{ state_object[schema.field_name]?.split("-")[1] }}
        </div>
      </div>
      <div v-else class="font-inter text-base font-semibold text-strongest">No answer selected</div>

      <!-- Occupation / Employer shown when employment_status is Employed or Self-Employed -->
      <div
        v-if="
          schema.field_name === 'employment_status' &&
          (state_object[schema.field_name] === 'Employed' ||
            state_object[schema.field_name] === 'Self-Employed')
        "
        class="mt-3 flex flex-col md:flex-row gap-3"
      >
        <div class="flex-1">
          <BaseInput
            label="Occupation"
            field_name="occupation"
            field_type="string"
            :modelValue="dataStore.contact.occupation"
            :read_only="true"
            variant="secondary"
          />
        </div>
        <div class="flex-1">
          <BaseInput
            label="Employer"
            field_name="employer"
            field_type="string"
            :modelValue="dataStore.contact.employer"
            :read_only="true"
            variant="secondary"
          />
        </div>
      </div>

      <!-- Securities employer fields shown when employed_by_security_or_financial_regulatory is Yes -->
      <div
        v-if="
          schema.field_name === 'employed_by_security_or_financial_regulatory' &&
          state_object[schema.field_name] === 'Yes'
        "
        class="mt-3 flex flex-col gap-3"
      >
        <div class="flex flex-col md:flex-row gap-3">
          <div class="flex-1">
            <BaseInput
              label="Employer Entity Name"
              field_name="securities_employer_name"
              field_type="string"
              :modelValue="dataStore.contact.securities_employer_name"
              :read_only="true"
              variant="secondary"
            />
          </div>
          <div class="flex-1">
            <BaseInput
              label="Employer Address"
              field_name="securities_employer_address"
              field_type="string"
              :modelValue="dataStore.contact.securities_employer_address"
              :read_only="true"
              variant="secondary"
            />
          </div>
        </div>
        <div
          v-if="securitiesEmployerDoc"
          class="flex items-center gap-2 px-3 py-2 rounded-xl bg-container-bg border border-outline-dividers w-fit"
        >
          <Icon name="FileText" class="h-4 w-4 shrink-0 text-strong" />
          <span class="text-sm font-inter text-strongest truncate max-w-56">{{
            securitiesEmployerDoc.file_name
          }}</span>
          <button
            type="button"
            @click="downloadFile_R2(securitiesEmployerDoc)"
            class="ml-2 flex items-center text-info hover:text-strongest"
          >
            <Icon name="Download" class="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { BaseInput, Icon } from "@/components";
import { useDataStore } from "@/stores";
import useFileUtility from "@/composables/useFileUtility";

const dataStore = useDataStore();
const { downloadFile_R2 } = useFileUtility();

const securitiesEmployerDoc = computed(
  () => dataStore.documents?.find((d) => d.file_category === "Securities Employer") ?? null
);

const props = defineProps({
  schema_array: { type: Array, required: true },
  state_object: { type: Object, required: true },
});
// let test = {
//   current_income: 23424,
//   bonds_allocation: "None",
//   risk_willingness: "Speculative",
//   source_of_income: "JOB",
//   current_net_worth: 424234234,
//   marginal_tax_rate: "Greater than 30%",
//   equities_allocation: "None",
//   self_responsibility: "Yes",
//   investment_objective:
//     "Growth & Income- you seek a moderate increase in investment value in combination with some income",
//   investment_experience: "Less than 2 years",
//   annual_living_expenses: "Greater than $100,000",
//   real_estate_allocation: "Greater than $250,000 USD",
//   investment_time_horizon: "Over 10 years",
//   current_liquid_net_worth: 324234,
//   other_investments_allocation: "Greater than $250,000 USD",
//   overall_portfolio_percentage: "26% and over",
//   significant_liquid_net_worth: "Yes",
//   risky_investment_understanding: "Yes",
// };
</script>
